// extracted by mini-css-extract-plugin
export var collapsedSummary = "_s8-0";